import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import CreateIcon from '@material-ui/icons/Create'
import CircularProgress from '@material-ui/core/CircularProgress'
import TextField from '@material-ui/core/TextField'
import classNames from 'classnames'
import green from '@material-ui/core/colors/green'
import Snackbar from '@material-ui/core/Snackbar'
import { withStyles } from '@material-ui/core/styles'

import apiService from '../../../services/Api'

const styles = (theme: any) => ({
  button: {
    margin: theme.spacing.unit,
  },
  buttonSuccess: {
    margin: theme.spacing.unit,
    '&:hover': {
      backgroundColor: green[700],
    }
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  }
})

export interface CreateKeyProps {
  userId: string
  apiId: string
  open: boolean
  onClose: () => void
  classes: any
}

export interface CreateKeyState {
  open: boolean
  name: string
  openSnackbar: boolean
  loading: boolean
  success: boolean
}

class CreateKey extends React.Component<CreateKeyProps, CreateKeyState> {

  constructor(props: CreateKeyProps) {
    super(props)
    this.state = {
      open: props.open,
      name: '',
      success: false,
      loading: false,
      openSnackbar: false

    }
    this.handleCreate = this.handleCreate.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleCloseSnackbar = this.handleCloseSnackbar.bind(this)
  }

  componentDidUpdate(prevProps: CreateKeyProps) {
    if (this.props.open !== prevProps.open) {
      this.setState((state, props) => ({
        open: props.open
      }))
    }
  }

  handleCloseSnackbar(event: any, reason: string): void {
    this.setState({ openSnackbar: false });
  }

  handleCancel(): void {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  async handleCreate(): Promise<void> {
    const { userId, apiId } = this.props
    const { name } = this.state
    this.setState({
      loading: true
    })
    await new apiService().createKey(apiId, name, userId)
    this.setState({
      loading: false,
      success: true,
      open: false,
      openSnackbar: true
    })
    this.props.onClose()
  }

  handleChange = (name: string) => (event: any) => {
    this.setState({
      name: event.target.value,
    })
  }

  render() {
    const { classes } = this.props
    const { loading, success, open, openSnackbar } = this.state
    const buttonClassname = classNames({
      [classes.buttonSuccess]: success,
    })
    return (
      <div>
        <Dialog open={open} aria-labelledby="Delete key">
          <DialogTitle id="simple-dialog-title">Create key</DialogTitle>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                required
                id="name"
                label="Required"
                className={classes.textField}
                margin="normal"
                placeholder="Key name"
                onChange={this.handleChange('name')}
              />
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCreate} variant="contained" color="secondary" disabled={loading} className={buttonClassname}>
              Create
            <CreateIcon className={classes.rightIcon} />
              {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </Button>
            <Button onClick={this.handleCancel} className={classes.button}>
              Cancel
        </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={openSnackbar}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">Successfully created</span>}
          autoHideDuration={3000}
          onClose={this.handleCloseSnackbar}
        />
      </div>
    )
  }
}

export default withStyles(styles)(CreateKey)
